/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
/** Custom Hooks */
import useDebounce from "../../../app/customHooks/useDebounce";
/** Common Components */
import CardSection from "../../../components/ui/card/CardSection";
import MolGrid from "../../../components/grid/MolGrid";
import CenterModel from "../../../components/ui/centerModel/CenterModel";
/** Common Services & Data Files */
import AddProjectVersion from "./ProjectVersion/AddProjectVersion";
import ToastService from "../../../services/toastService/ToastService";
import SwalAlert from "../../../services/swalService/SwalService";
import { decryptUrlData } from "../../../services/CryptoService";
/** RTK Query */
import {
  useDeleteProjectVersionMutation,
  useGetProjectVersionListMutation,
} from "../../../app/services/projectVersionAPI";
/** Configuration Files */
import { ProjectVersionGridConfig } from "./ProjectVersion/config/ProjectVersion.data";

const ProjectVersion = forwardRef((props, ref) => {
  const molGridRef = useRef();
  const { confirm } = SwalAlert();
  /* State*/
  const [isModelOpen, setisModelOpen] = useState(false);
  const [projectVersionGridData, setProjectVersionGridData] = useState();
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [selectedId, setSelectedId] = useState(null);
  const [searchText] = useState("");
  const debouncedSearch = useDebounce(searchText, 300);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  let projectId = null;
  let projectName = '';
  let projectCode = '';

  const { id } = useParams();
  const projectdata = id ? decryptUrlData(id) : null;

  if (typeof projectdata === 'object' && projectdata !== null) {
    projectId = projectdata.projectId;
    projectName = projectdata.projectName;
    projectCode = projectdata.projectCode;

  } else if (projectdata) {
    projectId = projectdata;
  }
  const cardData = [
    { key: projectCode, value: projectName },
  ];
  // API'S Call
  const [getAllProjectVersionList, {
    isLoading: isProjectVersionListLoading,
    isSuccess: isProjectVersionListSuccess,
    data: isLProjectVersionListeData,
  },] = useGetProjectVersionListMutation();

  const [deleteProjectVersion, {
    isSuccess: isProjectVersionDeleted,
    data: deleteProjectVersionData
  },] = useDeleteProjectVersionMutation();

  //** useEffect's */
  useEffect(() => {
    if (isProjectVersionListSuccess && isLProjectVersionListeData) {
      if (isLProjectVersionListeData) {
        const modifyData = isLProjectVersionListeData.dataSource.map((data) => ({
          ...data,
          releaseDate: data?.releaseDate ? data.releaseDate : null,
        }));
        setProjectVersionGridData(modifyData);
      }
      if (isLProjectVersionListeData.totalRecord) {
        setTotalRowCount(isLProjectVersionListeData.totalRecord);
      }
    }
  }, [isProjectVersionListSuccess, isLProjectVersionListeData]);

  useEffect(() => {
    if (isProjectVersionDeleted && deleteProjectVersionData) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      ToastService.success(deleteProjectVersionData.errorMessage);
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
      };
      getProjectDataList(request);
    }
  }, [isProjectVersionDeleted, deleteProjectVersionData]);

  useEffect(() => {
    if (ref) {
      ref.current = {
        refreshGrid: () => {
          if (molGridRef.current) {
            const currentPageObject = molGridRef.current.getCurrentPageObject();
            const request = {
              pagination: {
                pageNumber: currentPageObject.pageNumber,
                pageSize: currentPageObject.pageSize,
              },
            };
            getProjectDataList(request);
          }
        },
      };
    }
  }, [ref]);

  useEffect(() => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
      };
      getProjectDataList(request);
    }
  }, [props.search]);

  //** Funcation's */
  const getProjectDataList = (pageObject) => {
    const request = {
      pagination: {
        pageNumber: pageObject.pageNumber,
        pageSize: pageObject.pageSize,
      },
      projectId: projectId,
    };
    getAllProjectVersionList(request);
  };

  const handleToggleModal = () => {
    setisModelOpen(true);
  };

  const onDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteProjectVersion(data.projectVersionId);
      }
    });
  };

  const onEditAction = (data) => {
    setSelectedId(data.projectVersionId);
    setisModelOpen(true);
  };

  const onSuccess = () => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
      };
      getProjectDataList(request);
    }
  }

  const onSidebarClose = () => {
    setisModelOpen(false);
    setSelectedId(null);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page.pageNumber);
    setPageSize(page.pageSize);

    const request = {
      pagination: { pageNumber: page.pageNumber, pageSize: page.pageSize },
      filters: { searchText: debouncedSearch },
    };
    getProjectDataList(request);
  };

  const actionHandler = {
    EDIT: onEditAction,
    DELETE: onDeleteClick,
  };

  return (
    <div className="table-style">
      <div className="project-version center-top-space">
        {/* Filter Section Start */}
        <div className="main-filter-section">
          <CardSection
            isContentLoading={isProjectVersionListLoading}
            cardTitle={"Project Version"}
            rightButton={true}
            cardInfo={true}
            cardInfoWrapper={cardData}
            buttonClassName="theme-btn"
            titleButtonClick={handleToggleModal}
            buttonText="Version"
            textWithIcon={true}
            iconName="material-symbols:add-rounded"
            fontIcon={true}
          >
            <div className="table-grid">
              <div className="project-list">
                <MolGrid
                  ref={molGridRef}
                  configuration={ProjectVersionGridConfig}
                  dataSource={projectVersionGridData}
                  isLoading={isProjectVersionListLoading}
                  allowPagination={true}
                  pagination={{
                    totalCount: totalRowCount,
                    pageSize: pageSize,
                    currentPage: currentPage,
                  }}
                  onPageChange={handlePageChange}
                  onActionChange={actionHandler}
                />
              </div>
            </div>
          </CardSection>
        </div>
      </div>
      <div>
        {isModelOpen && (
          <CenterModel
            showModal={isModelOpen}
            handleToggleModal={onSidebarClose}
            modalTitle={
              selectedId ? "Update Project Version" : "Add Project Version"
            }
            modelSizeClass="w-40"
          >
            <AddProjectVersion
              onSidebarClose={onSidebarClose}
              showModal={isModelOpen}
              selectedId={selectedId}
              onSuccess={onSuccess}
            />
          </CenterModel>
        )}
      </div>
    </div>
  );
});

ProjectVersion.propTypes = {
  search: PropTypes.string,
  selectedStatusOptions: PropTypes.number,
};

export default ProjectVersion;
